module.exports = __webpack_public_path__ + "img/29.1aea2576.png";